import * as React from 'react';
import {
  Show,
  SimpleShowLayout,
  DateField,
  TextField,
  Datagrid,
  ArrayField,
} from 'react-admin';

const UserTitle = ({ record }) => {
  return (
    <span>User {record ? `"${record.name}"` : 'User name is empty :('}</span>
  );
};

const PreviewImages = ({ record }) =>
  record.images
    ? record.images.map((imgURL) => (
        <img
          src={imgURL}
          alt="img"
          style={{ width: '300px', padding: '1em' }}
        />
      ))
    : null;

const FaceImage = ({ record }) =>
  record.face !== undefined ? (
    <img
      src={record.face.faceUrl}
      alt="faceUrl"
      style={{ width: '300px', padding: '1em' }}
    />
  ) : (
    <div />
  );

export const UserShow = (props) => (
  <Show title={<UserTitle />} {...props}>
    <SimpleShowLayout>
      <PreviewImages />
      <TextField source="face.pose" />
      <FaceImage />
      <ArrayField source="metas" label="Other info">
        <Datagrid>
          <TextField source="question.name" label="Question" />
          <TextField source="answer" />
        </Datagrid>
      </ArrayField>
      <TextField source="linked" />
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="isFaceVerificated" />
      <TextField source="gender" />
      <TextField source="weight" />
      <TextField source="diamond" />
      <DateField source="birthday" />
      <TextField source="interestedGender" />
      <TextField source="areaCode" />
      <TextField source="phone" />
      <TextField source="ip" />
      <TextField source="isActive" />
      <TextField source="isFake" />
    </SimpleShowLayout>
  </Show>
);
